import { render, staticRenderFns } from "./Notifies.vue?vue&type=template&id=1e97fb68&"
import script from "./Notifies.vue?vue&type=script&lang=js&"
export * from "./Notifies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports